import React, { useEffect } from 'react';
import cx from 'classnames';
import Menu from '../Menu/Menu';
import MenuItem from '../Menu/MenuItem';
import Icon from '../Icon/Icon';

export const OptionsMenu = ({ menuRef, className, customStyles, options, onSelect, topOffset = 0, rightOffset = 0 }) => {

    const [openedMenuPosition, setOpenedMenuPosition] = React.useState({});
    const [loading, setLoading] = React.useState(true);

    useEffect(() => {
        console.log('OptionsMenu useEffect', menuRef.current, customStyles, topOffset, rightOffset);
        if (menuRef.current) {
            const BOTTOM_MENU_OFFSET = 120;
            const LEFT_MENU_OFFSET = 70;
            const customStylesTop = customStyles?.hasOwnProperty('top') ? customStyles?.top : 0;
            const height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
            const { offsetHeight, offsetTop, offsetWidth, offsetLeft, offsetParent } = menuRef.current;
            const menuRect = menuRef.current.getBoundingClientRect();
            const positionY = menuRect.y - offsetTop + BOTTOM_MENU_OFFSET + customStylesTop;
            console.log('positionY', positionY, 'offsetTop', offsetTop, 'customStylesTop', customStylesTop, 'offsetHeight', offsetHeight, 'height', height);
            let top = '';
            if (topOffset) {
                if (positionY + offsetHeight > height) {
                    // If menu will cross top and bottom boundaries - show it in the middle
                    if (menuRect.y - offsetTop - offsetHeight < 0) {
                        if (Math.abs(customStylesTop)) {
                            let topPosition = customStylesTop - offsetHeight / 2;
                            if (topPosition + offsetHeight >= height) {
                                topPosition -= topPosition + offsetHeight - height + 30;
                            }
                            top = topPosition;
                        } else {
                            top = '-50%';
                        }
                    } else {
                        // If only bottom boundary is crossed - show menu on the top of three dots button
                        top = customStylesTop - offsetHeight - 32;
                    }
                } else if (positionY < 0) {
                    top = customStylesTop + positionY;
                } else {
                    top = customStyles?.top;
                }
            } else {
                top = customStyles?.top;
            }
            let left = '';
            if (customStyles?.hasOwnProperty('left')) {
                left = customStyles.left;
            }
            if (rightOffset) {
                const containerRect = offsetParent?.offsetParent?.getBoundingClientRect();
                const width = containerRect.x + containerRect.width;
                if (customStyles?.hasOwnProperty('left')) {
                    if (left + offsetWidth > width) {
                        left = width - offsetWidth - LEFT_MENU_OFFSET;
                    }
                } else {
                    const positionX = menuRect.x - offsetLeft + LEFT_MENU_OFFSET;
                    left = positionX + offsetWidth > width ? '0px' : '';
                }
            }

            const styles = { top, left };
            if (customStyles?.hasOwnProperty('position')) {
                styles.position = customStyles.position;
            }

            if (customStyles?.hasOwnProperty('transform')) {
                styles.transform = customStyles.transform;
            }

            setOpenedMenuPosition(styles);
            setLoading(false);
        }
    }, [menuRef]);

    return <Menu className={className} ref={menuRef} customStyles={{ ...openedMenuPosition, opacity: loading ? '0' : '1' }}>
        {options.map((option, index) => (
            <MenuItem
                key={option.id || `option-menu-item-${index}`}
                onClick={() => onSelect(option)}
                disabled={option.disabled}
                className={cx('option', option.className)}
                onHover={option.tooltip}
            >
                {options.icon ? <Icon src={option.icon} className={cx('icon', option.iconClassName)} /> : null}
                <span className={cx('label', option.labelClassName)}>{option.label}</span>
            </MenuItem>))}
    </Menu>
} 